/**
 * Two independent stored fields: `billing_status` (on/off) and `billing_type`
 * (which scheme, Market or LIMOSS). LIMOSS keys still accrue charges; they are
 * held out of monthly market invoicing and billed separately.
 *
 * A key's billing status can only be turned on once it has a billing type -
 * see GlobalUMRStatusToggle's gating.
 */
export const BILLING_MARKET = 'Market'
export const BILLING_LIMOSS = 'LIMOSS'

export const BILLING_OPTIONS = [
  { value: BILLING_MARKET, text: BILLING_MARKET },
  { value: BILLING_LIMOSS, text: BILLING_LIMOSS }
]

// BDX List filter value for keys with no billing type yet (stored NULL - no lead
// underwriter config decides it, so no charge is created).
export const BILLING_TYPE_NULL = 'Null'

/* ------------------------------------------------------------------------- *
 * Underwriter-level billing type
 *
 * Separate from everything above, which is a per-KEY control. This is the pair
 * of independent switches set per underwriter on the Billing Status page; a
 * key's own type is then resolved from these two plus the key's FCP flag and
 * stored server-side.
 *
 * Deliberately not expressed through BILLING_OPTIONS: that has no notion of
 * "no opinion", so routing this through it would report a key as Market when
 * in fact nothing has been set.
 * ------------------------------------------------------------------------- */

export const SCHEME_MARKET = 'market'
export const SCHEME_LIMOSS = 'limoss'

export const SCHEME_LABELS = {
  [SCHEME_MARKET]: 'LimeIQ Market',
  [SCHEME_LIMOSS]: 'LIMOSS'
}

/** Tooltip on the Billing Type header. All three scenarios, per the ticket. */
export const BILLING_TYPE_SCENARIOS = [
  {
    title: 'Market only',
    body: 'All keys are billed via the Market method regardless of FCP status; any existing LIMOSS configuration is overridden.'
  },
  {
    title: 'Market + LIMOSS',
    body: 'FCP keys are billed via LIMOSS, non-FCP keys via Market. Slip Share must be completed 100% per key for the correct billing split per underwriter; if not, LIMOSS billing defaults to the lead underwriter only.'
  },
  {
    title: 'LIMOSS only',
    body: 'All keys are billed via LIMOSS, FCP flag ignored. Slip Share must be completed 100% per key; if not, defaults to the lead underwriter only.'
  }
]

/**
 * Earliest date a start date may be set to: tomorrow.
 *
 * The daily activation job needs a run before the date arrives, so a same-day
 * start would never be picked up. Mirrors the server-side rule - this only saves
 * the user a round trip, it is not the guard.
 */
export const isBeforeEarliestStart = (d) => {
  const midnightTomorrow = new Date()
  midnightTomorrow.setHours(0, 0, 0, 0)
  midnightTomorrow.setDate(midnightTomorrow.getDate() + 1)
  return d < midnightTomorrow
}
